import React from 'react';
import { Flex, Heading } from 'rebass';
import styled from 'styled-components';

const InfoWrapper = styled(Flex)`
  max-width: 860px;
  text-align: center;
  line-height: 1.5;
`;

interface MessagePageProps {
  text: string;
}

const MessagePage: React.FC<MessagePageProps> = ({ text }): JSX.Element => {
  return (
    <Flex justifyContent="center" pt={20} pb={10}>
      <InfoWrapper flexDirection="column" alignItems="center">
        <Heading fontSize={['42px']} fontWeight={6} css="max-width: 600px; white-space: pre-wrap">
          {text}
        </Heading>
      </InfoWrapper>
    </Flex>
  );
};

export default MessagePage;
